import { motion } from "framer-motion";

export const AnimatedPage = ({ children, animations }) => {
  
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.5 }}
    >

      {children}

    </motion.div>
  );
};
